import script from "./PresetMockupColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PresetMockupColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./PresetMockupColorPicker.vue?vue&type=style&index=0&id=0abdd089&lang=scss"

const __exports__ = script;

export default __exports__